import { render } from "./PageFormFormulirPsb.vue?vue&type=template&id=efd1628c"
import script from "./PageFormFormulirPsb.vue?vue&type=script&lang=js"
export * from "./PageFormFormulirPsb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__